module.exports = __webpack_public_path__ + "img/warning-triangle.71f92873.svg";